import { ReportingPeriodSelect } from 'teacher-ui-client/components/reporting/period-select'
import { ReportingControls } from 'teacher-ui-client/components/reporting/controls'
import { ReportingControlsGap } from 'teacher-ui-client/components/reporting/controls-gap'
import { StudentSearchComponent } from 'teacher-ui-client/components/student-search'
import { ReportingExportSelect, type ExportOption } from 'teacher-ui-client/components/reporting/export-select'
import { ReportingTableOrChartSelector } from 'teacher-ui-client/components/reporting/table-or-chart-selector'
import { not, and } from 'ember-truth-helpers'
import type Student from 'teacher-ui-client/models/student'
import type { TOC } from '@ember/component/template-only'

interface Args {
  routePrefix?: string
  chartRoute?: string
  tableRoute?: string
  student?: Student
  students: Student[]
  studentRouteName: string
  allStudentsRouteName: string
  exportOptions: ExportOption[]
  isDataPresent: boolean
}

interface Signature {
  Args: Args
  Element: Element
}

export const ReportingStudentSummaryControls: TOC<Signature> = <template>
  <ReportingControls>
    <ReportingPeriodSelect data-test-student-date-range />

    <ReportingControlsGap />

    {{#if @routePrefix}}
      <ReportingTableOrChartSelector @routePrefix={{@routePrefix}} />
    {{else if (and @chartRoute @tableRoute)}}
      <ReportingTableOrChartSelector
        @studentId={{@student.id}}
        @chartRoute={{@chartRoute}}
        @tableRoute={{@tableRoute}}
      />
    {{/if}}

    <ReportingExportSelect @exportOptions={{@exportOptions}} @disabled={{not @isDataPresent}} />

    <ReportingControlsGap />

    <StudentSearchComponent
      @studentRouteName={{@studentRouteName}}
      @classRouteName={{@allStudentsRouteName}}
      @students={{@students}}
      @excludedStudent={{@student}}
      @includeSelectAll={{true}}
    />
  </ReportingControls>
</template>

export default ReportingStudentSummaryControls
